import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, IsEnum, isNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class QcDefectItemDetailsDto{

@ApiProperty()
@IsNotEmpty({message:"qcdefectitemId Id not be empty"})
@IsAlphanumeric()
qcdefectitemId: number;

@ApiProperty()
qcId:number
@ApiProperty()
testResultId:number;

@ApiProperty()
rejectedQuantity:number;

@ApiProperty()
createdAt:Date;
@ApiProperty()
createdUser: string;
@ApiProperty()
updatedAt: Date;

@ApiProperty()
isActive: boolean;
 updatedUser : string;

 
 @ApiProperty()
 versionFlag : number;

}